export const home = '/';
export const logout = '/logout';
export const forgotPassword = '/esqueci-minha-senha';
export const completeSignUp = '/completar-cadastro';
